//with help from Medium (2018) URL: https://medium.com/@harishv6665_49536/theming-with-react-js-or-any-in-minutes-with-css-variables-11d4ebecdb41
import {createContext, useState, useEffect, useContext} from "react";

const ThemeContext = createContext();

export const ThemeSelector = ({ children }) => {
    //stores what theme the browser is currently using. if its using light, set the variable to light v/v
    const browserDefaultTheme = window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";

    //get saved theme. if there is nothing saved, default to browser theme
    const [theme, setTheme] = useState(localStorage.getItem("theme") || browserDefaultTheme);

    useEffect(() => {
        document.querySelector("body").setAttribute("data-theme", theme);
        localStorage.setItem("theme", theme);
    }, [theme]);

    const changeTheme = () => {
        //if the current theme is light change it to dark v/v
        setTheme((currentTheme) => (currentTheme === "light" ? "dark" : "light"));
    };

    return (
        <ThemeContext.Provider value={{theme, changeTheme}}>
            {children}
        </ThemeContext.Provider>
    )
};
export const useThemeSelector = () => useContext(ThemeContext);
